import { ElementRef } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
var Datos_proyectoComponent = /** @class */ (function () {
    function Datos_proyectoComponent() {
        this.rows = [];
        this.form = new FormGroup({
            datos: new FormControl('', Validators.required)
        });
        if (!JSON.parse(localStorage.getItem("datos_proyecto"))) {
            localStorage.setItem("datos_proyecto", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("datos_proyecto"));
            this.form.controls['datos'].setValue(this.rows[0] ? this.rows[0].datos : false);
        }
    }
    Datos_proyectoComponent.prototype.add_datos_proyecto = function () {
        this.actualRow = localStorage.getItem("datos_proyecto");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            datos: this.form.value.datos
        });
        localStorage.setItem("datos_proyecto", JSON.stringify(this.rows));
    };
    Datos_proyectoComponent.prototype.delete_datos_proyecto = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("datos_proyecto", JSON.stringify(this.rows));
            }
        }
    };
    return Datos_proyectoComponent;
}());
export { Datos_proyectoComponent };
